export const schema = {
  scenario: [
    {
      name: 'campaignLandscapeEditBid',
      value: 'campaignLandscapeEditBid',
      setting: {},
      activity: [
        {
          name: 'campaignLandscapeEditBid',
          value: 'campaignLandscapeEditBid',
        },
        {
          name: 'FetchedCampaignBidLandscape',
          value: 'FetchedCampaignBidLandscape',
        },
      ],
    },
  ],
};
